import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';

import Modal from '../../commons/modal/modal';
import Select from '../../commons/formElements/select/select';
import TextArea from '../../commons/formElements/textArea/textArea';
import {
  vehicleAvailabilitySelectOptions,
  vehicleAvailabilityDropdownSizeNameValStrings,
  vehicleAvailabilityStatusEnums
} from './manageVehiclesHelper';

import styles from './updateVehicleAvailabilityModal.scss';

const UpdateVehicleAvailabilityModal = props => {
  const [selectedAvailability, setSelectedAvailability] = useState(null);
  const [reason, setReason] = useState('');

  const {
    title,
    showModal,
    closeModal,
    vehicleData,
    updateVehicleAvailability
  } = props;

  const handleAvailabilitySelect = (val, obj) => {
    if (obj) {
      setSelectedAvailability(obj);
    }
  };

  const handleReasonChange = value => {
    setReason(value);
  };

  const handleCloseModal = () => {
    setSelectedAvailability(null);
    setReason('');
    closeModal();
  };

  /**
   * validateData: To check for data validations for compulsory fields
   *
   * @returns {boolean}
   */
  const validateData = () => {
    let isValid = true;
    const selectedOption =
      (selectedAvailability && selectedAvailability.value) || '';
    const formattedReason = (reason && reason.trim()) || '';

    if (!selectedOption.length) {
      isValid = false;
      toastr.error('Error', 'Select Vehicle Availability Option');
    } else if (
      selectedOption &&
      selectedOption.length &&
      selectedOption === vehicleAvailabilityStatusEnums.SOFT_BLOCKED &&
      !formattedReason.length
    ) {
      isValid = false;
      toastr.error('Error', 'Enter Valid Reason');
    }

    return isValid;
  };

  /**
   * getSubmitDataObject: get data final object to submit
   *
   * @returns {{}}
   */
  const getSubmitDataObject = () => {
    const dataObj = {};
    dataObj.ownerName = vehicleData.ownerName || null;
    dataObj.ownerType = vehicleData.ownerType || null;
    dataObj.purchaseMonthAndYear = vehicleData.purchaseMonthAndYear || null;
    dataObj.rcFrontS3Url = vehicleData.rcFrontS3Url || null;
    dataObj.rcBackS3Url = vehicleData.rcBackS3Url || null;
    dataObj.vehicleFrontViewS3Url = vehicleData.vehicleFrontViewS3Url || null;
    dataObj.vehicleRearViewS3Url = vehicleData.vehicleRearViewS3Url || null;
    dataObj.vehicleRightViewS3Url = vehicleData.vehicleRightViewS3Url || null;
    dataObj.vehicleLeftViewS3Url = vehicleData.vehicleLeftViewS3Url || null;
    dataObj.registrationNumber = vehicleData.registrationNumber || null;
    dataObj.vehicleBodyType = vehicleData.vehicleBodyType || null;
    dataObj.vehicleNumber = vehicleData.vehicleNumber || null;
    dataObj.vehicleTypeId = vehicleData.vehicleTypeId || null;
    dataObj.vehicleS3Urls = vehicleData.vehicleS3Urls || null;
    dataObj.vendorType = vehicleData.vendorType || null;
    dataObj.vendorName = vehicleData.vendorName || null;
    dataObj.vendorId = vehicleData.vendorId || null;
    dataObj.vehicleAvailabilityStatus =
      (selectedAvailability && selectedAvailability.value) || null;
    dataObj.rtoDate = vehicleData.rtoDate || null;
    dataObj.pucDate = vehicleData.pucDate || null;
    dataObj.fitnessExpiryDate = vehicleData.fitnessExpiryDate || null;
    dataObj.permitExpiryDate = vehicleData.permitExpiryDate || null;
    dataObj.insuranceExpiryDate = vehicleData.insuranceExpiryDate || null;
    dataObj.maxVehicleAgeInYears = vehicleData.maxVehicleAgeInYears || null;
    dataObj.vehicleBlockingReason = reason || '';
    dataObj.id = vehicleData.id || null;

    return dataObj;
  };

  const handleSubmit = () => {
    if (validateData()) {
      updateVehicleAvailability(getSubmitDataObject());
      handleCloseModal();
    }
  };

  return (
    <Modal showModal={showModal} title={title} closeModal={handleCloseModal}>
      <div className={styles.modalContainer}>
        <div className={styles.modalContent}>
          <div className={styles.formField}>
            <div className={styles.label}>Select Vehicle Availability</div>
            <div className={styles.inputFieldCtr}>
              <Select
                label="Select Availability"
                selectedOpt={selectedAvailability}
                optionsArrOfObj={vehicleAvailabilitySelectOptions || []}
                nameValStrings={vehicleAvailabilityDropdownSizeNameValStrings}
                onSelect={(val, obj) => {
                  handleAvailabilitySelect(val, obj);
                }}
                disabled={false}
                enableSearch={false}
                disableNone={true}
                selectedWrapperClass="select-field-wrapper white-background"
                inputClassName={styles.inputField}
              />
            </div>
          </div>

          {selectedAvailability &&
            selectedAvailability.value ===
              vehicleAvailabilityStatusEnums.SOFT_BLOCKED && (
              <div className={styles.textAreaDiv}>
                <TextArea
                  inputClassName={styles.textAreaInput}
                  placeholder="Enter valid reason"
                  rows={6}
                  value={reason}
                  onChange={handleReasonChange}
                />
              </div>
            )}

          <div className={styles.buttonsContainer}>
            <div
              className={`${styles.actionButton} ${styles.cancelBtn}`}
              onClick={handleCloseModal}
            >
              Cancel
            </div>
            <div
              className={`${styles.actionButton} ${styles.confirmBtn}`}
              onClick={handleSubmit}
            >
              Confirm
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateVehicleAvailabilityModal;
